import React from "react";
import { FaCopyright, FaPenFancy } from "react-icons/fa";
import "./Endfooter.css";

const Endfooter = () => {
  return (
    <footer className="endfooter mt-3">
      <div className="footer-container">
        <div className="footer-content">
          {/* Copyright Section */}
          <div className="footer-section copyright-section">
            <p className="footer-text">
              <FaCopyright className="footer-icon" />{" "}
              <a
                href="https://www.kalanjiyam.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Kalanjiyam
              </a>{" "}
              <span className="footer-year">2025</span> - © Exclusive Content |
              All Rights Reserved
            </p>
          </div>

          {/* Developer Section */}
          <div className="footer-section developer-section">
            <p className="footer-text">
              <FaPenFancy className="footer-icon" /> Designed & Developed by{" "}
              <a
                href="https://www.dremerz.net"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Dremerz Consultancy & Services
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Endfooter;
